<template>
    <div class="add-new-main-dialog">
        <el-dialog :visible="visible" title="查重客户信息" width="1230px" :close-on-click-modal='false'
            :close-on-press-escape='false' v-loading="addNewMainLoading" @close="handleClose">
            <div class="add-main-form-box">
                <table-box class="add-main-dialog-table" v-loading="neoCrmOpportunityList.tableLoading" ref="tableBox"
                    :selection="false" :height="config.height" :columns="config.columns"
                    :rows="neoCrmOpportunityList.totalData" :highlight-current-row="true">
                </table-box>
                <lots-pagination class="add-customer-duplicate-pagination"
                    @size-change="neoCrmOpportunityList.sizeChange" :current-page.sync="neoCrmOpportunityList.pageNo"
                    @current-change="neoCrmOpportunityList.pageChange" layout="total, sizes, prev, pager, next, jumper"
                    :total="neoCrmOpportunityList.pageTotal"
                    :pageSize="neoCrmOpportunityList.pageSize"></lots-pagination>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, computed } from '@vue/composition-api';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { ListClass } from '@/modules/mdm/composition/dc/common/list/ListClass';
import { tableConfig } from './config.js';
import { getCustomerPage } from '@/modules/mdm/api/customer/customerManage.js';

export default {
    components: { tableBox, lotsPagination },
    props: {
        addNewMainLoading: {
            type: Boolean,
            default: false
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        const emit = setupContext.emit;
        class DataDetailClass extends ListClass {
            beforeGetList(condition) {
                condition.customerName = currentparams.value.customerName;
                return condition;
            };
            afterGetList(res) {
                if (+res.code === 0) {
                    neoCrmOpportunityList.totalData.value = res.data.list;
                    neoCrmOpportunityList.pageTotal.value = res.data.totalCount;
                }
            }
        };

        const neoCrmOpportunityList = new DataDetailClass({
            Api: {
                listApi: getCustomerPage
            }
        });
        const FIELDS = computed(() => {
            return config.fields;
        });

        const visible = ref(false);
        const currentparams = ref({});
        const show = (val) => {
            visible.value = true;
            currentparams.value.customerName = val;
            neoCrmOpportunityList.getList();
        };
        const handleClose = () => {
            visible.value = false;
        };
        return {
            emit,
            config,
            neoCrmOpportunityList,
            FIELDS,
            visible,
            show,
            handleClose
        };
    }
};
</script>
<style lang="less" scoped>
.add-new-main-dialog {
    .add-main-form-box {
        width: 100%;
        padding: 0 20px 0 0;
        box-sizing: border-box;

        .el-select {
            width: 100%;
        }
    }

    .add-main-dialog-table {
        margin: 10px 0 5px 0;
    }

    .add-customer-duplicate-pagination {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
